import { parseJwt } from '@services/auth/AuthService';
import { User } from 'oidc-client-ts';

export const useIsAdminUser = (): UseIsAdminUserReturnType => {
  const storedUser = localStorage.getItem('user');

  if (storedUser !== null) {
    const user: User = JSON.parse(storedUser);
    const parsedToken = parseJwt(user.access_token);
    const isShadowUser = parsedToken.isShadowLogin === 'True';
    const userName = parsedToken.userName;
    const firstName = parsedToken.firstName;
    const lastName = parsedToken.lastName;

    if (userName.toLowerCase().endsWith('@automotivemastermind.com')) {
      return {
        isAdminUser: true,
        isShadowUser: isShadowUser,
        isError: false,
        userName: userName,
        firstName: firstName,
        lastName: lastName,
      };
    }
    return {
      isAdminUser: false,
      isShadowUser: false,
      isError: false,
      userName: userName,
      firstName: firstName,
      lastName: lastName,
    };
  } else {
    return {
      isAdminUser: false,
      isShadowUser: false,
      isError: true,
      userName: '',
      firstName: '',
      lastName: '',
    };
  }
};

export type UseIsAdminUserReturnType = {
  isAdminUser: boolean;
  isShadowUser: boolean;
  isError: boolean;
  userName: string;
  firstName: string;
  lastName: string;
};
